module.exports = __webpack_public_path__ + "img/event-ic-btn-02.ebef20d2.png";